import React from "react";
import { Link } from "react-router-dom";

/* Landing mínima de marca Viaja de Verdad. El producto real es el visor
   público (/trip/:token). Esta página existe solo para la raíz del dominio. */
export default function Landing() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center px-6 text-center"
      style={{ backgroundColor: "#121B28" }}
      data-testid="landing-page"
    >
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;1,400&family=Manrope:wght@300;400;600&display=swap');`}</style>
      <img
        src="/brand/vdv-logo-sand.webp"
        alt="Viaja de Verdad"
        className="h-16 w-auto sm:h-20"
        data-testid="landing-logo"
      />
      <p
        className="mt-8 text-2xl font-light italic text-white/90 sm:text-3xl"
        style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
      >
        Focused on you
      </p>
      <p
        className="mt-4 max-w-md text-sm font-light leading-relaxed text-white/60"
        style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}
      >
        Aquí viven los itinerarios de tus viajes. Si tienes un enlace personal,
        ábrelo para ver tu propuesta día a día.
      </p>
      <Link
        to="/admin"
        className="mt-10 text-[11px] uppercase tracking-[0.25em] text-white/30 transition-colors hover:text-white/70"
        style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}
        data-testid="landing-admin-link"
      >
        Panel
      </Link>
    </div>
  );
}
